<div class="page-subheader" *ngIf="title">
  <div class="container-fluid">{{ title }}</div>
</div>
<div class="page-content h-100">
  <div class="container-fluid">
    <ng-content></ng-content>
  </div>
</div>
